import { useMutation } from "@tanstack/react-query";
import { actualizarPerfil } from "../services/ActualizarPerfil.service";
import customAlert from "@/shared/components/CustomAlert";

/**
 * Hook para manejar la actualización de perfil
 * Envía los datos del formulario con archivo convertido a base64
 */
export const useActualizarPerfil = (t?: (key: string) => string) => {
  return useMutation({
    mutationFn: actualizarPerfil,
    onSuccess: (response) => {
      customAlert({
        icon: 'success',
        titulo: t ? t('actualizarPerfil.hookMessages.success.title') : 'Perfil actualizado exitosamente',
        mensaje: t ? t('actualizarPerfil.hookMessages.success.message') : 'Tu perfil ha sido actualizado de Ciudadano a Abogado.',
        tiempo: 8,
        toast: true,
      });
    },
    onError: (error: Error) => {
      customAlert({
        icon: 'error',
        titulo: t ? t('actualizarPerfil.hookMessages.error.title') : 'Error al enviar solicitud',
        mensaje: error.message || (t ? t('actualizarPerfil.hookMessages.error.message') : 'No se pudo procesar tu solicitud. Inténtalo de nuevo.'),
        tiempo: 8,
        toast: true,
      });
    },
  });
};
